import request from "@/utils/request";

export function getFollowInfo(id) {
  return request({
    url: "/product/activity/collect/" + id,
    method: "get",
  });
}

export function follow(data) {
  return request({
    url: "/product/activity/collect",
    method: "post",
    data,
  });
}

export function unfollow(params) {
  return request({
    url: "/product/activity/remove-collect",
    method: "put",
    params,
  });
}
